import "react-datepicker/dist/react-datepicker.css";

import { Calendar } from 'primereact/calendar';
import { Row } from "react-bootstrap";
import { addLocale } from 'primereact/api';
import { format } from "date-fns";
import pt from 'date-fns/locale/pt-BR';
import { useState } from "react";

addLocale('pt', {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar',
    dateFormat: 'dd/mm/yyyy',
    weekHeader: 'Sem',
});
const ReportFullFilter = ({ changeDates }) => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    
    const [dates, setDates] = useState([firstDayOfMonth, today]);
    
    const [hasChange, setHasChange] = useState(false);


    const handleCalendarHide = () => {
        if (hasChange) {
            if (changeDates) {
                const [startDate, endDate] = dates
                changeDates(formatDate(startDate), formatDate(endDate))
            }
        }
    }

    function formatDate(date) {
        if (date === null || date === undefined) return null;
        return format(date, 'yyyy-MM-dd', { locale: pt })
    }

    function onChangeDates(dates) {
        setDates(dates)
        setHasChange(true)
    }

    return (
        <div
            className='d-flex justify-content-center'
            style={{
                zIndex: 999,
                backgroundColor: '#fff',
                position: 'absolute',
                left: 0,
                right: 0,
                width: '100%',
                height: '60px',
                overflowX: 'hidden'
            }}>
            <Row style={{ paddingTop: '10px', padding: '6px' }}>
                <Calendar maxDate={new Date()}
                    style={{ height: '10px', width: '100%' , textAlign: 'center'}}
                    locale="pt"
                    dateFormat="dd/mm/y"
                    value={dates}
                    onChange={(e) => onChangeDates(e.value)}
                    selectionMode="range"
                    readOnlyInput
                    onHide={handleCalendarHide}
                    hideOnRangeSelection />
            </Row>
        </div>
    );
};

export default ReportFullFilter;